import { render } from "./ToolbarSelectMenu.vue?vue&type=template&id=2d0d40b4"
import script from "./ToolbarSelectMenu.vue?vue&type=script&lang=js"
export * from "./ToolbarSelectMenu.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__